import React from "react";
import { cn } from "@/lib/utils";

/**
 * TRALENEX — Company / master brand logo.
 *
 * Renders the OFFICIAL TRALENEX SVG asset exactly as supplied.
 * The asset lives at /brand/tralenex-logo.svg and MUST NOT be redrawn,
 * reinterpreted, simplified or substituted.
 *
 * Sizing controls the rendered height while preserving aspect ratio.
 */
export function TralenexLogo({
  className,
  height = 32,
  ariaLabel = "TRALENEX",
  ...rest
}) {
  return (
    <img
      src="/brand/tralenex-logo.svg"
      alt={ariaLabel}
      data-testid="tralenex-logo"
      className={cn("block select-none", className)}
      style={{ height, width: "auto" }}
      draggable={false}
      {...rest}
    />
  );
}

export default TralenexLogo;
